export const SUPPORT = {
    TICKET_URL: 'https://support.lokos.in/',
    EMAIL: 'support@lokos.in',
};
